import React from "react";
import { Seo } from "src/components/seo";
import AccessDeniedLockScreen from "src/components/access-denied-lock-screen";

/**
 * 403 Forbidden / Access Denied Page
 */
const Error403Page = () => {
  return (
    <>
      <Seo title="Error: 403 Forbidden" />
      <AccessDeniedLockScreen />
    </>
  );
};

export default Error403Page;
